// extracted by mini-css-extract-plugin
export default {"redesSociais":"Footer_redesSociais__mo+s+","linksFooter":"Footer_linksFooter__KeW+H","titleUl":"Footer_titleUl__hC1xw","copyright":"Footer_copyright__osQKF"};